export default {"src":"/_next/static/image/public/images/ic_visa.e7a0402aac9fad13a3341c35684e62ce.svg","height":22,"width":67};